module.exports = __webpack_public_path__ + "img/time-money.96507f56.svg";